document.addEventListener("DOMContentLoaded", () => {

  let basePrice = null

  function getPriceElement() {
    return document.querySelector('.price-item--regular, .price-item--sale')
  }

  function parsePrice(text) {
    return parseFloat(
      text
        .replace(/[^\d,.-]/g, '')
        .replace(',', '.')
    )
  }

  function getBasePrice() {

    if (basePrice !== null) return

    const priceEl = getPriceElement()
    if (!priceEl) return

    basePrice = parsePrice(priceEl.textContent)

  }

  function getFlecosExtra() {

    const selected = document.querySelector('input[name="properties[Flecos]"]:checked')

    if (!selected) return 0

    return parseFloat(selected.dataset.price) || 0

  }

  function updatePrice() {

    const priceEl = getPriceElement()
    if (!priceEl || basePrice === null) return

    const newPrice = basePrice + getFlecosExtra()

    priceEl.textContent = Math.round(newPrice) + "€"

  }

  /* cambio flecos */

  document.addEventListener('change', e => {

    if (e.target.matches('input[name="properties[Flecos]"]')) {
      updatePrice()
    }

  })

  /* cambio variante */

  document.addEventListener('variant:change', () => {

    setTimeout(() => {

      const priceEl = getPriceElement()
      if (!priceEl) return

      basePrice = parsePrice(priceEl.textContent)

      updatePrice()

    }, 100)

  })

  /* init */

  setTimeout(() => {
    getBasePrice()
    updatePrice()
  }, 300)

})